import Vue from "vue";
import Component from "vue-class-component";
import SidebarComponent from "@/components/sidebar/sidebar.component.vue";
import HeaderComponent from "@/components/header/header.component.vue";
import LoaderComponent from "@/components/loader/loader.component.vue";
import ModalPermissionsComponent from "@/components/modal-permissions/modal-permissions.component.vue";
import ModalLoginComponent from "@/components/modal-login/modal-login.component.vue";
import Datepicker from "vuejs-datepicker";
import CandidateService from "@/core/services/candidate.service";
import SidebarService from "@/core/services/sidebar.service";

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    Datepicker,
    ModalLoginComponent,
    LoaderComponent,
  },
})
export default class CreateEvaluatedComponent extends Vue {
  candidateService: any = new CandidateService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  isDuplicatedUser: boolean = false;
  genericErr: any = [];
  candidateList: any = [];
  companyList: any = [];
  reporterList: any = [];
  jobList: any = [];
  bossEmail = "";
  isBossMailRequired: boolean = false;
  name: string = "";
  surname: string = "";
  birthdate: string = "";
  email: string = "";
  password: string = "";
  confirm_password: string = "";
  country: string = "";
  companies: any = false;
  jobs: string = "defaultJob";
  job: string = "";
  reporters: string = "defaultReporters";
  reporter: string = "";
  manuallyPassword: boolean = false;
  assignedSurveys: Array<number> = [];
  mainSurveySelected: number = 0;
  isTrainingSuperAdmin: boolean = false;
  isMainSurveySelected: boolean = false;
  isSuperAdminRole: boolean = false;
  hasCompanyAct: boolean = false;
  hasCompanySMAP: boolean = false;
  autoGeneratedPassword: any = Math.random().toString(36).slice(-8);

  allowedSurveys: any[] = [];

  mounted() {
    const _ = this;
    _.getCompanies();
    _.getJobs();
    _.getReporters();
    _.isTrainingAdmin();
    _.isSuperAdmin();
  }

  closeSidebar() {
    const _ = this;
    _.sidebarService.close();
  }

  getCompanies() {
    const _ = this;
    _.isLoading = true;
    _.candidateService
      .getCompanies()
      .then((data: any) => {
        _.companyList = data["data"].companies;
        _.companyList.sort(function (a, b) {
          var textA = a.name.toLowerCase();
          var textB = b.name.toLowerCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        if (err.response.data.message.includes("Invalid or inexistent user")) {
          localStorage.removeItem("tk_auth");
          _.logInModal = true;
        }
        _.isLoading = false;
      });
  }

  getReporters() {
    const _ = this;
    _.isLoading = true;
    _.candidateService
      .getReporters()
      .then((data: any) => {
        _.reporterList = data["data"].reporters;
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
      });
  }

  getJobs() {
    const _ = this;
    _.isLoading = true;
    _.candidateService
      .getJobs()
      .then((data: any) => {
        _.jobList = data["data"].jobs;
        setTimeout(() => {
          _.isLoading = false;
        }, 1500);
      })
      .catch((err: any) => {
        _.isLoading = false;
      });
  }

  assignSurveys(surveyId: number) {
    const _ = this;
    if (_.assignedSurveys.includes(surveyId)) {
      _.assignedSurveys = _.assignedSurveys.filter((survey: number) => {
        return survey !== surveyId;
      });
      return;
    }

    _.assignedSurveys.push(surveyId);
  }

  create() {
    const _ = this;
    let candidate = {
      name: _.name,
      surname: _.surname,
      birthdate: _.birthdate,
      email: _.email ? _.email.toLowerCase() : "",
      password: _.manuallyPassword ? _.password : _.autoGeneratedPassword,
      jobId: _.jobs,
      companyId: _.companies,
      responsibleId: _.reporters,
      surveys: [1, 2, ..._.assignedSurveys],
    };

    if (_.assignedSurveys.length === 0) {
      alert("Selecciona una encuesta de la lista");
      return;
    }

    if (_.isBossMailRequired) {
      if (_.bossEmail === "") {
        alert("Por favor pon un correo alternativo");
        return;
      }
      candidate["recipientOverride"] = _.bossEmail;
    }
    _.isLoading = true;
    _.candidateService
      .create(candidate)
      .then((data: any) => {
        _.isSuccess = true;
        _.isErrorServer = false;
        _.isDuplicatedUser = false;
        _.error = false;
        _.modal = true;
        setTimeout(() => {
          _.isLoading = false;
          _.$router.push("/evaluated");
        }, 2000);
        // _.assingCompanies(data['data'].user.id, _.companies);
      })
      .catch((err: any) => {
        _.modal = true;
        _.error = true;
        const message =
          err.response && err.response.data ? err.response.data.message : "";
        _.isDuplicatedUser =
          typeof message === "string" &&
          message.indexOf("SequelizeUniqueConstraintError") !== -1;
        _.isErrorServer = !_.isDuplicatedUser;
        setTimeout(() => {
          _.isLoading = false;
        }, 2000);
      });
  }

  assingCompanies(user_id: any, company_id: any) {
    const _ = this;
    _.candidateService
      .assingCompanies(user_id, company_id)
      .then((data: any) => {});
  }

  validations(
    name = "",
    surname = "",
    email = "",
    password = "",
    confirm_password = "",
    companies = "",
    jobs = "defaultJob",
    reporters = "defaultReporters"
  ) {
    const _ = this;
    _.genericErr = [];
    let emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (name == "") {
      _.genericErr.push("Por favor escribe tu nombre");
      _.error = true;
      _.modal = true;
    }
    if (surname == "") {
      _.genericErr.push("Por favor escribe tu apellido");
      _.error = true;
      _.modal = true;
    }
    if (!emailRegex.test(email.toLowerCase()) && email != "") {
      _.genericErr.push("Correo invalido");
      _.error = true;
      _.modal = true;
    }
    if (email == "") {
      _.genericErr.push("Por favor escribe un correo");
    }
    if (password == "" && _.manuallyPassword) {
      _.genericErr.push("Por favor escribe una contraseña");
    }
    if (password.length < 6 && password != "" && _.manuallyPassword) {
      _.genericErr.push("La constraseña debe tener minimo 6 caracteres");
    }
    if (password != confirm_password && _.manuallyPassword) {
      _.genericErr.push("Las constraseñas no coinciden");
    }
    if (companies == "") {
      _.genericErr.push("Por favor selecciona una compañía");
    }
    if (jobs == "defaultJob") {
      _.genericErr.push("Por favor selecciona un puesto");
    }
    if (reporters == "defaultReporters") {
      _.genericErr.push("Por favor selecciona un reporteador");
    }
    if (_.genericErr.length > 0) {
      _.modal = true;
      _.error = true;
      return;
    }
    _.create();
  }

  private isTrainingAdmin() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    if (companyId === "null" || companyId === "1") {
      _.isTrainingSuperAdmin = true;
    }
  }

  private isSuperAdmin() {
    const _ = this;
    const role = localStorage.getItem("role");
    _.isSuperAdminRole = role === "1";
  }

  public getCompanySurveys() {
    this.assignedSurveys = [];
    this.candidateService
      .getCompanySurveys(this.companies)
      .then((data: any) => {
        this.allowedSurveys = data.data.surveys.filter((survey: any) => {
          if (survey.id > 2) {
            return {
              id: survey.id,
              name: survey.name,
            };
          }
        });
      });
  }
}
